import { Extended, Short } from './BrandLogo.styles'

const BrandLogo = {
  Extended,
  Short,
}

export { BrandLogo }
